import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userInviteActions } from '_actions';
import { storageKey } from '_constants';

export function usePasswordStatusRedirect(currentPage) {
    const dispatch = useDispatch();
    const passwordStatus = useSelector((state) => state.userInvite.passwordStatus);
    const loading = passwordStatus?.loading;
    const hasRedirectedRef = useRef(false);

    useEffect(() => {
        const cached = JSON.parse(localStorage.getItem(storageKey.PASSWORD_STATUS));
        if (cached) {
            const redirected = redirectIfNeeded(currentPage, cached);
            if (redirected) {
                hasRedirectedRef.current = true;
            }
        }

        dispatch(userInviteActions.passwordStatus());
    }, [currentPage]);

    useEffect(() => {
        if (!loading && passwordStatus?.data && !hasRedirectedRef.current) {
            const redirected = redirectIfNeeded(currentPage, passwordStatus.data);
            if (redirected) {
                hasRedirectedRef.current = true;
            }
        }
    }, [loading, passwordStatus?.data, currentPage]);

    function redirectIfNeeded(currentPage, status) {
        const hasUserSetOwnPassword = status?.hasUserSetOwnPassword;

        if (hasUserSetOwnPassword === false && currentPage !== 'create') {
            console.log("Redirecting to /create-password");
            window.location.href = '/create-password';
            return true;
        }

        if (hasUserSetOwnPassword === true && currentPage !== 'update') {
            console.log("Redirecting to /update-password");
            window.location.href = '/update-password';
            return true;
        }

        return false;
    }
}

